import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getWalletDependentCards = ({ userId }) =>
  call(websocketFetch, 'get_wallet_dependent_cards', { user_id: userId });
